"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _stencilReactDesc = require("@amzn/stencil-react-desc");

var _WithPopover = _interopRequireDefault(require("./WithPopover"));

var _Trigger = _interopRequireDefault(require("./Trigger"));

var _sharedPropTypes = require("./sharedPropTypes");

var _core = require("@emotion/core");

var WithPopoverRegular = function WithPopoverRegular(_ref) {
  var children = _ref.children,
      props = (0, _objectWithoutProperties2.default)(_ref, ["children"]);
  return (// Padding to move the popover container away from the trigger and
    // avoid overlapping the text
    (0, _core.jsx)(_WithPopover.default, (0, _extends2.default)({
      padding: "4px 0"
    }, props), function (_ref2) {
      var isOpen = _ref2.isOpen,
          toggle = _ref2.toggle,
          ariaHasPopup = _ref2['aria-haspopup'];
      return (0, _core.jsx)(_Trigger.default, {
        isOpen: isOpen,
        onClick: toggle,
        "aria-haspopup": ariaHasPopup
      }, children);
    })
  );
};

WithPopoverRegular.displayName = 'WithPopoverRegular';
var WithPopoverRegularWithDocs = (0, _stencilReactDesc.describe)(WithPopoverRegular).description('FAC component to show a popover triggered by a tertiary button.');
WithPopoverRegularWithDocs.propTypes = (0, _objectSpread2.default)({}, _sharedPropTypes.sharedPropTypes, {
  children: _stencilReactDesc.PropTypes.node.description('Content to display in the trigger button.')
});
var _default = WithPopoverRegularWithDocs;
exports.default = _default;